// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { app, dialog } from '@microsoft/teams-js';
import { useTranslation } from 'react-i18next';
import {
    makeStyles,
    tokens,
    shorthands,
    Text,
} from '@fluentui/react-components';

const useStyles = makeStyles({
    errorMessage: {
        ...shorthands.margin('1rem'),
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        color: tokens.colorPaletteRedForeground3,
    },
});

const ErrorPage = () => {
    const { t } = useTranslation();
    const styles = useStyles();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const message = searchParams.get('message');
    useEffect(() => {
        app.notifySuccess();
        if (app.getFrameContext() && app.getFrameContext() !== 'settings') {
            dialog.update.resize({
                height: 100,
                width: 500,
            });
        }
    }, []);

    function parseErrorMessage(): string {
        if (!!message) {
            return message;
        } else if (id === '401') {
            return t('UnauthorizedErrorMessage');
        } else if (id === '403') {
            return t('ForbiddenErrorMessage');
        }

        return t('GeneralErrorMessage');
    }

    return <Text className={styles.errorMessage}>{parseErrorMessage()}</Text>;
};

export default ErrorPage;
